// extracted by mini-css-extract-plugin
export default {"colorViolet":"#080837","image":"HpoCCLJzLyGNvxJp3McY","medium":"eb_oJ41U98UpbPAAAEb1","large":"sik05q20Ix95poP_GcAE","invertedColor":"YGHKW0QzN85TV_DHUFXw"};